import React, { useEffect, useState } from 'react';

import Routes from './routes';
import { theme } from './themes';
import { ProvideAuth } from './providers/authentication';
import { ThemeProvider, CircularProgress } from '@mui/material';
import { AuthenticationResult, PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './azure/authConfig';

const msalInstance = new PublicClientApplication(msalConfig);

function App() {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  useEffect(() => {
    setIsLoading(true);
    msalInstance.handleRedirectPromise().finally(() => setIsLoading(false));
  }, []);
  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          backgroundColor: '#ACCEF7',
          backgroundSize: 'cover',
          background: 'white'
        }}
      >
        <CircularProgress color="inherit" />
      </div>
    );
  }
  return (
    <ThemeProvider theme={theme}>
      <MsalProvider instance={msalInstance}>
        <ProvideAuth>
          <Routes />
        </ProvideAuth>
      </MsalProvider>
    </ThemeProvider>
  );
}

export default App;
